import React, { useContext } from 'react';
import { M30ProductFeaturesCardProps } from 'ui/components/2-molecules/Card/M30ProductFeaturesCard/M30ProductFeaturesCard';
import { M30ProductFeatures } from 'ui/components/3-organisms/M30ProductFeatures';
import { DictionaryContext } from 'application/adapters/context/Dictionary';

export const M30ProductFeaturesFeature: React.FC<Umbraco.M30ProductFeatures> = ({ content }) => {
	const { heading, features, background, anchor } = content?.properties ?? {};
	const dictionary = useContext(DictionaryContext);

	const mappedFeaturesCard: M30ProductFeaturesCardProps[] = features.map(({ content }) => {
		const { image, text, title, youtubeLink } = content?.properties ?? {};

		return {
			image,
			text,
			title,
			youtubeLink,
		};
	});

	return (
		<M30ProductFeatures
			products={mappedFeaturesCard}
			heading={heading}
			backgroundColorKey={background}
			anchor={anchor}
			consentHeading={dictionary.getValue('Video.ConsentHeading', null, 'Video unavailable')}
			consentText={dictionary.getValue(
				'Video.ConsentText',
				null,
				'To watch this video, please update your cookie preferences in the bottom-left corner of the page.',
			)}
		/>
	);
};
